<div class="modal-header">
  <h3 class="modal-title">Supplemental Info</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

@if (autoRunDataLoad) {
<mat-progress-bar
  color="primary"
  mode="indeterminate">
</mat-progress-bar>
}

@if (!autoRunDataLoad) {
<div class="modal-body supplemental-modal-body" [hidden]="minimise">
  <div class="panel-body">
    @if (scenarioDesc !== 'RAF') {
<table>
        <caption class="sr-only">Supplemental information history</caption>
      <tr>
        <div style="margin-right: 5px">Issue Id:</div>
        <td>
          <div class="a-m-10">
            <ap-dropdown class="m-l-10 issueIdDropdown" [list]="issueIdList" [selectType]="'single'"
              [disabled]="isEditFlag" [title]="'Select Issue Id'" [hideTitleOnInput]="true" [inputAriaLabel]="'Issue Id'"
              [(ngModel)]="selectedIssueItem" (onSelect)="setIssueId($event, 0);">
              @for (item of issueIdList; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setAriaLabel(item, 'Issue Id')" (onSelectItem)="onDropdownSelectItem($event)">
              </ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
        </td>
        @if (issueIdCheckFlag) {
<td>
          <div>
            <span class="noRecords">Please select Issue Id</span>
          </div>
        </td>
}
      </tr>
    </table>
}

    <div class="supplemental-form-scroll">
      <div>
        <table class="table table-striped blue" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="11" style="text-align: center;">Supplemental Info Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Illegal Payments </td>
              <td>
                <div class="text-center a-m-10">
                  <input type="checkbox" [(ngModel)]="illegalPayments" (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Sanctioned Country </td>
              <td>
                <div class="text-center a-m-10">
                  <input type="checkbox" [(ngModel)]="sanctionedCountry" (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Purchase Inv US Related </td>
              <td>
                <div class="a-m-10">
                  <input type="number" [(ngModel)]="PurInvUsRel" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Purchase Inv Non US Related </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="PurInvNonUsRel" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
            </tr>
            <tr>
              @if (isEditFlag) {
<td>Cost Of Sales </td>
}
              @if (isEditFlag) {
<td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="CostSales" style="text-align: right !important;"
                    [disabled]="isEditFlag" (change)="getTestData();">
                </div>
              </td>
}
              @if (isEditFlag) {
<td></td>
}
              <td>Wages Cost Of Sales </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="WageCostSales" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Sales Tangible Prop US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="SalesTangPropUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Sales Tangible Prop Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="SalesTangPropNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
            </tr>
            <tr>
              <td>Purchase Tangible Prop US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="PurTangPropUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Purchase Tangible Prop Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="PurTangPropNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Buy In Receive US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="BuyInRecveUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Buy In Receive Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="BuyInRecveNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
            </tr>
            <tr>
              <td>Buy In Paid US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="BuyInPaidUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Buy In Paid Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="BuyInPaidNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Cost Sharing Receive US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="CostSharRecveUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Cost Sharing Receive Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="CostSharRecveNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
            </tr>
            <tr>
              <td>Cost Sharing Paid US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="CostSharPaidUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td>Cost Sharing Paid Non US </td>
              <td>
                <div class="ap-p-spacing-6">
                  <input type="number" [(ngModel)]="CostSharPaidNonUs" style="text-align: right !important;"
                    (change)="getTestData();">
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  @if (!tableLoadingData) {
<mat-progress-bar color="primary" mode="indeterminate">
  </mat-progress-bar>
}

  @if (tableData) {
<section class="supplemental-history-section">
    <div class="divShadow1">
      <ap-table #basicTable [data]="SavedData" [striped]="true">
        <table>
          <thead class="a-thead">
            <tr>
              <th>Delete</th>
              <th>Edit</th>
              @if (scenarioDesc !== 'RAF') {
<th>Issue Id</th>
}
              <th>Illegal Payments</th>
              <th>Sanctioned Country</th>
              <th>Purchase Inv US Related</th>
              <th>Purchase Inv Non US Related</th>
              <th>Cost Of Sales</th>
              <th>Wages Cost Of Sales</th>
              <th>Sales Tangible Prop US</th>
              <th>Sales Tangible Prop Non US</th>
              <th>Purchase Tangible Prop US</th>
              <th>Purchase Tangible Prop Non US</th>
              <th>Buy In Receive US</th>
              <th>Buy In Receive Non US</th>
              <th>Buy In Paid US</th>
              <th>Buy In Paid Non US</th>
              <th>Cost Sharing Receive US</th>
              <th>Cost Sharing Receive Non US</th>
              <th>Cost Sharing Paid US</th>
              <th>Cost Sharing Paid Non US</th>
            </tr>
          </thead>
          <tbody class="a-tbody tbody-regular tbody-hover">
            @for (item of basicTable.data; track $index; let i = $index) {
<tr>
              <td>
                <ap-button class="actioniconssuppl" [compact]="true" [btnType]="'tertiary'"
                  [disabled]="scenarioDesc !== 'RAF' && item.ISSUE_KEY === 0" (onClick)="btnClickDelete(item)">
                  <span class="Appkit4-icon icon-circle-minus-fill"></span>
                </ap-button>
              </td>
              <td>
                <ap-button class="actioniconssuppl" [compact]="true" [btnType]="'tertiary'"
                  [disabled]="scenarioDesc !== 'RAF' && item.ISSUE_KEY === 0" (onClick)="btnClickEdit(item)">
                  <span class="Appkit4-icon icon-edit-fill"></span>
                </ap-button>
              </td>
              @if (scenarioDesc !== 'RAF') {
<td>{{item.ISSUE_KEY}}</td>
}
              <td>{{item.ILLEGAL_PAYMENTS}}</td>
              <td>{{item.SANCTIONED_COUNTRY}}</td>
              <td class="amountALign">{{item.PURCHASE_INV_US_RELATED | number}}</td>
              <td class="amountALign">{{item.PURCHASE_INV_NONUS_RELATED | number}}</td>
              <td class="amountALign">{{item.COST_OF_SALES | number}}</td>
              <td class="amountALign">{{item.WAGES_COST_OF_SALES | number}}</td>
              <td class="amountALign">{{item.SALES_TANGIBLE_PROP_US | number}}</td>
              <td class="amountALign">{{item.SALES_TANGIBLE_PROP_NONUS | number}}</td>
              <td class="amountALign">{{item.PURCHASE_TANGIBLE_PROP_US | number}}</td>
              <td class="amountALign">{{item.PURCHASE_TANGIBLE_PROP_NONUS | number}}</td>
              <td class="amountALign">{{item.BUY_IN_RECEIVE_US | number}}</td>
              <td class="amountALign">{{item.BUY_IN_RECEIVE_NONUS | number}}</td>
              <td class="amountALign">{{item.BUY_IN_PAID_US | number}}</td>
              <td class="amountALign">{{item.BUY_IN_PAID_NONUS | number}}</td>
              <td class="amountALign">{{item.COST_SHARING_RECEIVE_US | number}}</td>
              <td class="amountALign">{{item.COST_SHARING_RECEIVE_NONUS | number}}</td>
              <td class="amountALign">{{item.COST_SHARING_PAID_US | number}}</td>
              <td class="amountALign">{{item.COST_SHARING_PAID_NONUS | number}}</td>
            </tr>
}
          </tbody>
        </table>
      </ap-table>
    </div>
  </section>
}
</div>
}

@if (!autoRunDataLoad) {
<div class="modal-footer supplemental-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="saveData()">Save</button>
  <button class="reset-button" type="button" (click)="resetData()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
}
